import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merge conditional class names, letting later Tailwind utilities win over
 * earlier conflicting ones (e.g. `cn("p-2", "p-4")` yields `p-4`). Plain
 * template strings cannot do this, which is why every shadcn component uses it.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

const dateTimeFormat = new Intl.DateTimeFormat(undefined, {
  weekday: "short",
  day: "numeric",
  month: "short",
  hour: "2-digit",
  minute: "2-digit",
});

/** Render a UTC timestamp from the API in the viewer's own locale and zone. */
export function formatDepartureTime(isoTimestamp: string): string {
  return dateTimeFormat.format(new Date(isoTimestamp));
}
